import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";
import { formatPlayCount, typeLabel } from "@/utils/format";

interface TopRankingProps {
  videos: Video[];
}

export default function TopRanking({ videos }: TopRankingProps) {
  const top = videos.slice(0, 10);

  return (
    <section className="w-full px-4 md:px-8">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-2.5 mb-5">
          <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
            热门视频榜单
          </h2>
          <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold">
            Top 10
          </span>
        </div>

        <div className="p-4 md:p-6 rounded-lg bg-secondary-50 border border-secondary-200">
          <ol className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1">
            {top.map((video, i) => (
              <li key={video.id}>
                <Link
                  to={`/detail/${video.id}`}
                  className="group flex items-center gap-3 py-2.5 px-2 rounded-md hover:bg-background-50 transition-colors cursor-pointer"
                >
                  <span
                    className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md text-sm font-bold ${
                      i < 3
                        ? "bg-accent-500 text-background-50 dark:text-foreground-950"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <span className="relative w-10 h-14 shrink-0 rounded-md overflow-hidden bg-background-200">
                    <img
                      src={video.cover}
                      alt={`${video.title} 封面`}
                      title={`${video.title} - 在线视频`}
                      className="w-full h-full object-cover object-top"
                    />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
                      {video.title}
                    </span>
                    <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="px-1.5 py-0.5 rounded bg-background-100 text-foreground-600">
                        {typeLabel(video.type)}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line text-accent-500"></i>
                        {formatPlayCount(video.playCount)}
                      </span>
                    </span>
                  </span>
                  <i className="ri-arrow-right-s-line text-lg text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}